import React from 'react';
import { LegalDocumentLayout } from './common/LegalDocumentLayout';
import { LegalSection, LegalList, LegalListItem, LegalSubsection } from './common/LegalSection';

export const TermsTrainer: React.FC = () => {
  return (
    <LegalDocumentLayout
      title={'Regulamin Trenera\nPlatformy Spotto.pl'}
      lastUpdated="03.04.2026"
    >
      <LegalSection number={1} title="Postanowienia ogólne">
        <LegalSubsection number="1.1.">
          Regulamin określa zasady współpracy Trenera z platformą rezerwacyjną SPOTTO.pl,
          prowadzoną przez SOLID LABS PSA („Administrator").
        </LegalSubsection>
        <LegalSubsection number="1.2.">
          Trenerem jest osoba fizyczna (w przypadku pracownika) lub podmiot gospodarczy,
          posiadający konto trenerskie w Platformie.
        </LegalSubsection>
        <LegalSubsection number="1.3.">
          Obiektem jest podmiot gospodarczy prowadzący działalność sportową lub rekreacyjną,
          udostępniający swoje usługi i powierzchnie Użytkownikom Platformy.
        </LegalSubsection>
        <LegalSubsection number="1.4.">
          Użytkownikiem Platformy jest każda osoba fizyczna lub prawna, która założyła konto
          i dokonuje rezerwacji lub zakupu usług sportowych, rekreacyjnych lub trenerskich.
        </LegalSubsection>
      </LegalSection>

      <LegalSection number={2} title="Kwalifikacje i obowiązki Trenera">
        <LegalSubsection number="2.1.">
          Trener oświadcza, że posiada:
        </LegalSubsection>
        <LegalList>
          <LegalListItem>wymagane kwalifikacje, licencje i certyfikaty,</LegalListItem>
          <LegalListItem>aktualne ubezpieczenie OC.</LegalListItem>
        </LegalList>
        <LegalSubsection number="2.2.">
          Na żądanie Administratora Trener zobowiązany jest przedstawić dokumenty potwierdzające
          uprawnienia.
        </LegalSubsection>
        <LegalSubsection number="2.3.">
          Trener ponosi pełną odpowiedzialność za bezpieczeństwo uczestników organizowanych
          treningów.
        </LegalSubsection>
        <LegalSubsection number="2.4.">
          Trener jest zobowiązany do przestrzegania zasad obowiązujących na Obiektach,
          w których prowadzi zajęcia.
        </LegalSubsection>
        <LegalSubsection number="2.5.">
          Trener jest zobowiązany do uprzedniego potwierdzenia możliwości odbycia treningu
          na planowanych warunkach z Obiektem, w którym mają odbyć się zajęcia.
        </LegalSubsection>
        <LegalSubsection number="2.6.">
          Trener zobowiązany jest do wskazania i utrzymywania na swoim profilu w Platformie
          Spotto aktualnych danych kontaktowych, w szczególności numeru telefonu oraz adresu
          poczty elektronicznej, umożliwiających Użytkownikom kontakt z Trenerem w celu
          uzyskania dodatkowych informacji, zgłaszania pytań oraz składania reklamacji.
        </LegalSubsection>
        <LegalSubsection number="2.7.">
          Trener zobowiązany jest przestrzegać zasad i regulaminów obowiązujących
          w wykorzystywanych systemach płatniczych, a w szczególności stosować się do
          ograniczeń sprzedaży produktów i usług zakazanych, np. broni, amunicji, środków
          podwójnego zastosowania, etc.
        </LegalSubsection>
      </LegalSection>

      <LegalSection number={3} title="Rezerwacje i płatności">
        <LegalSubsection number="3.1.">
          Rezerwacje treningów są odpłatne i realizowane za pośrednictwem systemu
          transakcyjnego Platformy.
        </LegalSubsection>
        <LegalSubsection number="3.2.">
          Każda rezerwacja treningu stanowi bezpośrednią umowę pomiędzy Trenerem
          a Użytkownikiem — Administrator nie jest jej stroną.
        </LegalSubsection>
      </LegalSection>

      <LegalSection number={4} title="Anulowanie treningów">
        <LegalSubsection number="4.1.">
          Platforma nie obsługuje anulowania treningów.
        </LegalSubsection>
        <LegalSubsection number="4.2.">
          Wszelkie zmiany lub odwołania treningów odbywają się poza Platformą, na
          odpowiedzialność Trenera i Użytkownika.
        </LegalSubsection>
        <LegalSubsection number="4.3.">
          W przypadku odwołania treningu z winy Trenera, Trener zobowiązany jest do pełnego
          zwrotu środków Użytkownikowi.
        </LegalSubsection>
      </LegalSection>

      <LegalSection number={5} title="Odpowiedzialność">
        <LegalSubsection number="5.1.">
          Trener ponosi pełną odpowiedzialność za:
        </LegalSubsection>
        <LegalList>
          <LegalListItem>przebieg i jakość treningu,</LegalListItem>
          <LegalListItem>bezpieczeństwo uczestników,</LegalListItem>
          <LegalListItem>zgodność usługi z opisem.</LegalListItem>
        </LegalList>
        <LegalSubsection number="5.2.">
          Administrator nie ponosi odpowiedzialności za działania lub zaniechania Trenera.
        </LegalSubsection>
        <LegalSubsection number="5.3.">
          Administrator dostarcza system transakcyjny i ponosi odpowiedzialność za
          funkcjonowanie systemu.
        </LegalSubsection>
        <LegalSubsection number="5.4.">
          Administrator nie jest stroną umowy ani stosunków prawnych pomiędzy Użytkownikiem
          a Obiektem lub Trenerem, w szczególności zawartej umowy sprzedaży, dlatego nie
          ponosi odpowiedzialności z nimi związanej.
        </LegalSubsection>
        <LegalSubsection number="5.5.">
          Administrator nie ponosi odpowiedzialności za niewykonanie lub nienależyte wykonanie
          zobowiązań ze strony Użytkownika na rzecz Trenera (brak wymaganej dopłaty za usługi
          płatne etc.).
        </LegalSubsection>
      </LegalSection>

      <LegalSection number={6} title="Reklamacje i zgłoszenia nieprawidłowości">
        <LegalSubsection number="6.1.">
          Reklamacje dotyczące treningów Użytkownicy kierują bezpośrednio do Trenera.
          Rekomenduje się podjęcie danej reklamacji w terminie nie przekraczającym 14 dni
          od daty wpływu zgłoszenia.
        </LegalSubsection>
        <LegalSubsection number="6.2.">
          Użytkownik ma prawo zgłosić Administratorowi przypadki nieuczciwego,
          nieprofesjonalnego lub niezgodnego z Regulaminem zachowania Trenera na adres:{' '}
          <a
            href="mailto:reklamacje@spotto.pl"
            className="text-brand-primary hover:text-brand-primary-hover transition-colors"
          >
            reklamacje@spotto.pl
          </a>
          .
        </LegalSubsection>
        <LegalSubsection number="6.3.">
          Administrator nie jest stroną rezerwacji i nie ponosi odpowiedzialności za działania
          Trenera.
        </LegalSubsection>
        <LegalSubsection number="6.4.">
          W przypadkach rażących naruszeń Administrator ma prawo zawiesić konto Trenera lub
          rozwiązać umowę współpracy ze skutkiem natychmiastowym.
        </LegalSubsection>
      </LegalSection>

      <LegalSection number={7} title="Dane osobowe">
        <LegalSubsection number="7.1.">
          Administratorem danych osobowych Użytkowników jest SOLID LABS PSA o numerze NIP:
          6751768986, z siedzibą w Krakowie przy ul. Mogilskiej 43, kod pocztowy 31-545.
        </LegalSubsection>
        <LegalSubsection number="7.2.">
          Dane osobowe przetwarzane są zgodnie z przepisami RODO oraz Polityką Prywatności
          Platformy. Kontakt w sprawach ochrony danych:{' '}
          <a
            href="mailto:rodo@spotto.pl"
            className="text-brand-primary hover:text-brand-primary-hover transition-colors"
          >
            rodo@spotto.pl
          </a>
          .
        </LegalSubsection>
        <LegalSubsection number="7.3.">
          Użytkownik ma prawo dostępu do danych, ich poprawiania, usunięcia oraz ograniczenia
          przetwarzania.
        </LegalSubsection>
      </LegalSection>

      <LegalSection number={8} title="Postanowienia końcowe">
        <LegalSubsection number="8.1.">
          Administrator zastrzega sobie prawo do monitorowania jakości usług.
        </LegalSubsection>
        <LegalSubsection number="8.2.">
          Regulamin podlega prawu polskiemu.
        </LegalSubsection>
        <LegalSubsection number="8.3.">
          Naruszenie Regulaminu może skutkować trwałym usunięciem konta Trenera.
        </LegalSubsection>
      </LegalSection>
    </LegalDocumentLayout>
  );
};
